export default __webpack_public_path__ + "static/media/j6.e18c7f67.png";